module.exports = __webpack_public_path__ + "static/media/Content-Preview-Frame.68273180.svg";